module.exports = __webpack_public_path__ + "img/0bbb9bbc-4361-49f1-9a32-32a16fb6f5e6.008.20fb9f81.png";